import React, { useState, useEffect } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { RESET_WIFI, GET_WIFI } from 'graphql/service';
import { useMutation, useLazyQuery } from '@apollo/client';
import { WifiIcon } from 'assets/icons';
import { Container, Separator } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalWifi = ({
  buttonStyle,
  roomBookingId,
  bookingId
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const [newNetworkName, setNewNetworkName] = useState('')
  const [newWifiPassword, setNewWifiPassword] = useState('')
  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
  const [failedIsOpen, setFailedIsOpen] = useState(false)

  const [getWifi, {data, error}] = useLazyQuery(GET_WIFI)

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  useEffect(() => {
    if(bookingId) {
      getWifi({
        variables: {
          input: {
            bookingId: bookingId
          }
        }
      })
    }
  }, [bookingId])

  const [resetWiFi, { loading }] = useMutation(RESET_WIFI, {
    onCompleted: (wifiData) => {
      if(wifiData.regenerateRoomBookingWiFiCredentials) {
      setNewNetworkName(wifiData.regenerateRoomBookingWiFiCredentials.ssid)
      setNewWifiPassword(wifiData.regenerateRoomBookingWiFiCredentials.password)
      setSuccessfullyIsOpen(true)
      setFailedIsOpen(false)
      setIsOpen(false)
      } else {
        setFailedIsOpen(true)
        setIsOpen(false)
      }
    },
    onError: (error) => {
      setFailedIsOpen(true)
      setIsOpen(false)
    }
  })

  const handleReset = () => {
    if(loading) return

    resetWiFi({
      variables: {
        input: {
          roomBookingId: roomBookingId
        }
      },
    })
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Wi-Fi"
        buttonStyle={buttonStyle}
        additionalstyle={`
          max-width: 504px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          top: 179px;
        `}
      >
        <Container>
          <WifiIcon />
          <div className="title">Current Wi-Fi Information</div>
          <div className="text">
            {`Wifi Network Name: ${data?.bookingWiFiCredentials?.[0].ssid}`}
          </div>
          <div className="text">
            {`Wifi Password: ${data?.bookingWiFiCredentials?.[0].password}`}
          </div>
          <Separator />
          <div className="title">Reset Wi-Fi Password</div>
          <div className="text">
            Note: this will invalidate the existing credentials and the guest will have to re-authenticate their devices. Only do this if the guest is experiencing an issue connecting.
          </div>
          <div className="buttonContainer">
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `}
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleReset}
              data-loading={loading}
              additionalstyle={`
                width: 74px;
              `}
            >
              {loading ? null : "Reset"}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        newNetworkName={newNetworkName}
        newWifiPassword={newWifiPassword}
        type='reset-wifi'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleReset}
        type='reset-wifi'
      />
    </>
  );
}

export default ModalWifi;
